// Reload the page when a new service worker takes control.
// In standalone PWA mode there is no refresh button — without this,
// users stay on stale JS forever after a deploy.
export function registerSwUpdateReload(): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}
